import { Directive, forwardRef, Input } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { BaseDocumentMaskDirective } from './base-document-mask.directive';

type CpfCnpjCacealType = 'cpf' | 'cnpj' | 'caceal' | 'both';

@Directive({
  selector: '[jhiCpfCnpjCacealMask]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CpfCnpjCacealMaskDirective),
      multi: true
    }
  ]
})
export class CpfCnpjCacealMaskDirective extends BaseDocumentMaskDirective {
  @Input('jhiCpfCnpjCacealMask') override type: CpfCnpjCacealType = 'both';

  protected validateDocument(value: string): boolean {
    switch (this.type) {
      case 'cpf':
        return this.isValidCPF(value);
      case 'cnpj':
        return this.isValidCNPJ(value);
      case 'caceal':
        return this.isValidCACEAL(value);
      case 'both':
        return this.isValidCPF(value) || this.isValidCNPJ(value) || this.isValidCACEAL(value);
      default:
        return false;
    }
  }

  protected formatDocument(value: string): string {
    if (this.type === 'caceal' && value.length <= 9) {
      return this.formatCaceal(value);
    } else if (this.type === 'cpf' && value.length <= 11) {
      return this.formatCPF(value);
    } else if (this.type === 'cnpj' && value.length <= 14) {
      return this.formatCNPJ(value);
    } else if (this.type === 'both') {
      return value.length <= 9 
        ? this.formatCaceal(value) 
        : (value.length <= 11 ? this.formatCPF(value) : this.formatCNPJ(value));
    }
    return value;
  }

  protected getMaxLength(): number {
    if (this.type === 'caceal') {
      return 9;
    }

    if (this.type === 'cpf') { 
      return 11;
    }

    if (this.type === 'cnpj') { 
      return 14;
    }

    return 14; // both
  }

  private formatCPF(cpf: string): string {
    if (cpf.length < 11) {
      return cpf;
    }
    return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6, 9)}-${cpf.slice(9, 11)}`;
  }

  private isValidCPF(cpf: string): boolean {
    return cpf.length === 11 && /^[0-9]{11}$/.test(cpf);
  }
}
